/**
 * @generated SignedSource<<77234976452042819c35cf9833c3913b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpcomingEventsDepartment_department$data = {
  readonly club: {
    readonly copyOverrides: {
      readonly event: {
        readonly plural: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly upcomingEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly startOn: string;
        readonly " $fragmentSpreads": FragmentRefs<"NewPatronEventCardWrapper">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly " $fragmentType": "UpcomingEventsDepartment_department";
};
export type UpcomingEventsDepartment_department$key = {
  readonly " $data"?: UpcomingEventsDepartment_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpcomingEventsDepartment_department">;
};

import UpcomingEventsDepartmentQuery_graphql from './UpcomingEventsDepartmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingEvents"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "endDate"
    },
    {
      "kind": "RootArgument",
      "name": "eventTags"
    },
    {
      "kind": "RootArgument",
      "name": "memberId"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UpcomingEventsDepartmentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UpcomingEventsDepartment_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClubCopyOverrides",
          "kind": "LinkedField",
          "name": "copyOverrides",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NounOverride",
              "kind": "LinkedField",
              "name": "event",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "plural",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "upcomingEvents",
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "startDate"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "endDate"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "tagIds",
          "variableName": "eventTags"
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "__UpcomingEventsDepartment_upcomingEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startOn",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NewPatronEventCardWrapper"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Department",
  "abstractKey": null
};
})();

(node as any).hash = "2b2e3f9a087381282f4cecba5f82dc15";

export default node;
